import { useUserManagementServiceV1 } from "@rw1/api-services";
import { UserManagement_V1 } from "@rw1/auto-generated-clients";
import { useMemo } from "react";
import { useFetchAll } from "../../../hooks/useFetchAll";

interface UseUsersOptions {
  companyId?: string;
  pageSize?: number;
  search?: string;
  enabled?: boolean;
  licenseId?: string;
}

export const USERS_QUERY_KEY = "users";

export const useUsers = (
  options: UseUsersOptions,
): {
  users: UserManagement_V1.UserWithCompanyName[];
  isLoading: boolean;
  totalUsers: number;
  isFetching: boolean;
  refetch: () => void;
} => {
  const {
    companyId,
    pageSize = 1000,
    search,
    enabled = true,
    licenseId,
  } = options;

  const userManagementService = useUserManagementServiceV1();
  const { data, isLoading, isFetching, refetch } =
    useFetchAll<UserManagement_V1.UserWithCompanyName>(
      [USERS_QUERY_KEY, companyId, { search, pageSize, licenseId }],
      (page, size) =>
        userManagementService.getUsersByCompany(
          companyId!,
          page,
          size,
          search ?? undefined,
          licenseId ?? undefined,
        ),
      {
        enabled: enabled && !!companyId,
        pageSize,
      },
    );

  return useMemo(
    () => ({
      users: data ?? [],
      isLoading,
      totalUsers: data?.length ?? 0,
      isFetching,
      refetch,
    }),
    [data, isLoading, isFetching, refetch],
  );
};
